import { Icon } from "./Icon.tsx";

/** "Patterns" tab icon — bars of alternating height (a repeating diurnal/
 * weekly multiplier cycle), distinct from SummaryIcon.tsx's own 3
 * monotonically-ascending bars (a one-off totals chart, not a cycle). */
export function PatternIcon() {
  return (
    <Icon>
      <path d="M4 20V14M8 20V8M12 20V16M16 20V6M20 20V12" />
    </Icon>
  );
}
